<template>
  <div class="vendor-title__container iw-layout-grid">
    <div class="iw-layout-grid__row">
      <div class="iw-layout-grid__col--span-12">
        <h1 class="vendor-title__text">
          <span>{{ activeVendor.name }}</span>
        </h1>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "VendorTitle",
  computed: {
    ...mapGetters("vendor", {
      activeVendor: "getActiveVendor"
    })
  }
};
</script>

<style scoped lang="scss">
.vendor-title {
  &__container {
    width: 100%;
  }
  &__text {
    margin-left: $spacer;
    font-weight: bold;
  }
}
</style>
